import { useLowBandwidthBanner } from '@frontend/react-domain/credits';
import { Button, Text, XStack } from '@frontend/web-react';
import { safeCss } from '@frontend/web-utils';
import { useRetrieveCreditsQuery } from '@frontend/web/hooks';
import { router } from '@frontend/web/router';

export const LowBandwidthChatBanner = () => {
  const { data: credits } = useRetrieveCreditsQuery();
  const { dismiss, shouldShowBanner } = useLowBandwidthBanner(credits);

  if (!shouldShowBanner) return null;

  const handleClick = () => {
    dismiss();
    router.navigate({ to: '/app/profile' });
  };

  return (
    <XStack
      className={safeCss(
        'bg-orange-50 rounded-t-lg px-md pt-sm pb-lg items-center justify-between cursor-pointer -mb-lg',
      )}
      onClick={handleClick}
    >
      <Text isSelectable={false} type="p-sm">
        Running low on bandwidth
      </Text>
      <Button
        className={safeCss('bg-orange-200! border-orange-200!')}
        label="Upgrade"
        onClick={handleClick}
        size="sm"
        variant="tertiary"
      />
    </XStack>
  );
};
